//  /////////////// COPYRIGHT © 2025/2026 IROÏD/DSTRKT™ FOR TIXFORGIGS
//  ////////////////////////////////////////////// ALL RIGHTS RESERVED
//  /////// LICENSED UNDER THE IROÏD LICENSE VERSION 1.0 [THE LICENSE]
//  /////// DO NOT USE THIS FILE EXCEPT IN COMPLIANCE WITH THE LICENSE
//
//  TixforGigs™ Unified API
//
//  VERSION: 4.6
//  PACKAGE: 4.6.297-SNAPSHOT
//  CONTACT: developer@tixforgigs.com
//  CREATED: 2026-02-26T01:20:10.489677Z
//
//  /////////////////////////////////////// AUTOGENERATED. DO NOT EDIT

@file:Suppress(
  "ArrayInDataClass",
  "EnumEntryName",
  "RemoveRedundantQualifierName",
  "UnusedImport"
)

package com.tixforgigs.apax.models

import com.tixforgigs.apax.models.Amount
import com.tixforgigs.apax.models.InvoiceType

        import kotlinx.serialization.*
  import kotlinx.serialization.descriptors.*
  import kotlinx.serialization.encoding.*

/**
* The invoice model.
* 
* @param invoiceDate The date and time when the event begins
* @param invoiceId The invoice id
* @param invoiceType 
* @param subTotal 
*/
@Serializable

data class Invoice (


      /* The date and time when the event begins */
    @SerialName(value = "invoiceDate") @Required val invoiceDate: kotlin.time.Instant,


      /* The invoice id */
    @SerialName(value = "invoiceId") @Required val invoiceId: kotlin.Int,


      @SerialName(value = "invoiceType") @Required val invoiceType: InvoiceType,


      @SerialName(value = "subTotal") @Required val subTotal: Amount


) {




  }

